import { useAuth } from "m2m-components/storage/useM2mAuth"
import { useMemo } from "react"
import React from "react"
import {
    PhotoTour,
    PhotoTourItem,
    usePhotoTourByCleaningId
} from "../../../hooks/usePhotoTour"
import { useCleaningDetail } from "./cleaningDetail"

export interface CleaningPhotoTourContextState {
    tour?: PhotoTour
    items?: PhotoTourItem[]
}

const CleaningPhotoTourContext = React.createContext<
    CleaningPhotoTourContextState | undefined
>(undefined)

export const CleaningPhotoTourProvider = ({
    children
}: React.PropsWithChildren) => {
    const { token } = useAuth()
    const { detail } = useCleaningDetail()
    const { data } = usePhotoTourByCleaningId(token, detail?.id)

    const value = useMemo(
        () => ({
            tour: data?.photoTour,
            items: data?.items
        }),
        [data?.items, data?.photoTour]
    )

    return (
        <CleaningPhotoTourContext.Provider value={value}>
            {children}
        </CleaningPhotoTourContext.Provider>
    )
}

export const useCleaningPhotoTourContext = () => {
    const ctx = React.useContext(CleaningPhotoTourContext)
    if (!ctx) {
        throw new Error(
            "useCleaningPhotoTourContext must be used within a CleaningPhotoTourProvider"
        )
    }

    return ctx
}
